import React, { useEffect, useMemo, useState } from "react";
import "./WhitelistedSender.css";
import { Messante_URL } from './apiConfig';
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

//     {
//         userId: "Aniljewell.web",
//         senderId: "ANILJ",
//         entityId: "1701169234224870158",
//         status: "Active",
//         senderType: "Transactional",
//         createdDate: "9/13/2026 6:19:40 PM"
//     },
//     {
//         userId: "Awign.web",
//         senderId: "AVCCLB",
//         entityId: "1201159600033054423",
//         status: "Active",
//         senderType: "Transactional",
//         createdDate: "8/24/2026 2:07:09 PM"
//     },
//     {
//         userId: "Awign.web",
//         senderId: "AVCTYR",
//         entityId: "1201159600033054423",
//         status: "Active",
//         senderType: "Transactional",
//         createdDate: "8/24/2026 2:07:17 PM"
//     },
//     {
//         userId: "Awign.web",
//         senderId: "JKBOND",
//         entityId: "1201159600033054423",
//         status: "Active",
//         senderType: "Transactional",
//         createdDate: "8/24/2026 2:07:49 PM"
//     },
//     {
//         userId: "Awign.web",
//         senderId: "JKKSAN",
//         entityId: "1201159600033054423",
//         status: "Active",
//         senderType: "Transactional",
//         createdDate: "8/24/2026 2:08:18 PM"
//     }
// ];

export default function ViewWhitelistedSender() {

    const [searchText, setSearchText] = useState("");
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [ViewSenderAPIData, setViewSenderAPIData] = useState([]);
    const [showprogress, setshowprogress] = useState(false);

    const loginData = JSON.parse(sessionStorage.getItem("loginData"));
    const sessionusertype = loginData?.utype?.usertype;
    const sessionusername = loginData?.guiuserid;

    const callViewAllSender = async (uname) => {
        try {
            console.log('calling callViewAllSender ');
            setshowprogress(true);
            const apiUrl = `${Messante_URL}/sender?uid=${sessionusername}&activityBy=${sessionusername}&callfor=viewAll`;
            const fetchOptions = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                }
            };

            // API Request
            const response = await fetch(apiUrl, fetchOptions);
            const data = await response.json();

            setshowprogress(false);

            if (data?.status === "Success" || data?.errorCode === "000") {
                const TemplateData = Array.isArray(data?.sndlist) ? data?.sndlist : [];
                setViewSenderAPIData(TemplateData);
            }

            else {
                const errorMessage = data?.status;
                const responseBody = await data?.errorDesc;
                setshowprogress(false);
                // const result = await Swal.fire({
                //     title: 'View All Senders Error',
                //     html: `${errorMessage}${responseBody}`,
                //     icon: 'error'
                // });
                setViewSenderAPIData([]);

            }

        }

        catch (error) {
            console.error("API Request Error:", error.message);
            setshowprogress(false);

            const result = await Swal.fire({
                title: 'API Request Error',
                html: error.message,
                icon: 'error'
            });
        }
    };

   // Global search only by Sender ID
const filteredData = useMemo(() => {

    const search = searchText.trim().toLowerCase();

    if (!search) {
        return ViewSenderAPIData;
    }

    return ViewSenderAPIData.filter((row) =>
        String(row.sender ?? "")
            .toLowerCase()
            .includes(search)
    );

}, [searchText, ViewSenderAPIData]);

    useEffect(()=>{
callViewAllSender();
    },[])

    return (
        <div
            className={
                isFullScreen
                    ? "whitelist-container fullscreen"
                    : "whitelist-container"
            }
        >

            {/* ================= HEADER ================= */}

            <div className="whitelist-header">

                <div className="whitelist-title">
                    Whitelisted Sender IDs
                </div>

                <div className="whitelist-actions">
                    <Link to="/senderwhitelist"
                        className="sender-submit-btn"
                        style={{textDecoration:"none", display:"flex", alignItems:"center", justifyContent:"center", textTransform:"none"}}
                    >
                        <i className="fa fa-reply" />
                        Back
                    </Link>
                </div>

            </div>


            {/* ================= SEARCH ================= */}

            <div className="search-container">

                <div className="search-icon">
                    <span>⌕</span>
                </div>

                <input
                    type="text"
                    placeholder="Search...."
                    value={searchText}
                    onChange={(e) =>
                        setSearchText(e.target.value)
                    }
                />

                {searchText && (
                    <button
                        className="clear-search"
                        onClick={() => setSearchText("")}
                    >
                        ×
                    </button>
                )}

            </div>


            {/* ================= TABLE ================= */}

            <div className="table-wrapper">

                <table className="sender-table">
                    <thead>
                        <tr>
                            <th>
                                <div className="th-content">
                                    <span>SENDER ID</span>
                                </div>
                            </th>

                            <th>
                                <div className="th-content">
                                    <span>ENTITY ID</span>
                                </div>
                            </th>

                            <th>
                                <div className="th-content">
                                    <span>STATUS</span>
                                </div>
                            </th>

                            <th>
                                <div className="th-content">
                                    <span>Sender Type</span>
                                </div>
                            </th>

                            <th>
                                <div className="th-content">
                                    <span>CREATED DATE (IST)</span>
                                </div>
                            </th>
                        </tr>
                    </thead>


                    <tbody>

                        {filteredData.length > 0 ? (

                            filteredData.map((row, index) => (

                                <tr key={index}>
                                    <td>
                                        {row.sender}
                                    </td>

                                    <td>
                                        {row.peid}
                                    </td>

                                    <td>
                                        <span
                                            className={
                                                row.status === "1"
                                                    ? "status-active"
                                                    : "status-inactive"
                                            }
                                        >
                                            {row.status === "1" ? "Active" : "InActive"}
                                        </span>
                                    </td>

                                    <td>
                                        {row.senderType === "0" ? "PROMOTIONAL" : "TRANSACTIONAL"}
                                    </td>

                                    <td>
                                        {row.createdate}
                                    </td>

                                </tr>

                            ))

                        ) : (

                            <tr>

                                <td
                                    colSpan="6"
                                    className="no-data"
                                >
                                    No sender IDs found
                                </td>

                            </tr>

                        )}

                    </tbody>

                </table>

            </div>


            {/* ================= FOOTER ================= */}

            <div className="table-footer">

                Showing{" "}
                <b>{filteredData.length}</b>{" "}
                of{" "}
                <b>{ViewSenderAPIData?.length}</b>{" "}
                records

            </div>

        </div>
    );
}